import FabRewardsComponent from "@smerewards/core-ui";
import ModalComponent from "./modal-component";
import { useState, useEffect } from "react";

function App() {
  const [token, setToken] = useState("");
  const [tokenFromStorage, setTokenFromStorage] = useState("");

  const authTokenKey = "SSO_TOKEN";
  const [languages, setLanguage] = useState("en");


  const handleChange = (e) => {
    const newLang = e.target.value;
    setLanguage(newLang);
    // i18n.changeLanguage(newLang);
    document.body.dir = newLang === "ar" ? "rtl" : "ltr";
  };

  useEffect(()=> {
    console.log("checking count")
  },[languages])

  const [showEnterTokenModal, setShowEnterTokenModal] = useState(false);

  useEffect(() => {
    let token = localStorage.getItem(authTokenKey);
    if (token) {
      setTokenFromStorage(token);
    } else {
      setShowEnterTokenModal(true);
    }
  }, []);

  console.log("showEnterTokenModal", showEnterTokenModal);

  return (
    <>
    <div
        className="language-dropdown"
        style={{
          position: "absolute",
          top: 20,
          "inset-inline-end": 20,
          // zIndex: 9999,
        }}
      >
        <select
          value={languages}
          onChange={handleChange}
          style={{
            padding: "6px 10px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            cursor: "pointer",
          }}
        >
          <option value="en">English</option>
          <option value="ar">Arabic</option>
        </select>
      </div>

      {showEnterTokenModal && (
        <ModalComponent
          id={"enter-token-modal"}
          isOpen={showEnterTokenModal}
          onClose={() => setShowEnterTokenModal(false)}
        >
          <h5 id="">Enter SSO token</h5>

          <div>
            <div
              style={{
                marginBottom: "25px",
              }}
            >
              <input
                type="text"
                style={{
                  width: "100%",
                  padding: "8px 10px",
                  borderRadius: "5px",
                  border: "1px solid rgba(0,0,0,0.1)",
                }}
                value={token}
                onChange={(e) => {
                  setToken(e.target.value);
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: "15px",
              }}
            >
              <button
                width="120px"
                onClick={() => {
                  if (token) {
                    localStorage.setItem(authTokenKey, token);

                    setShowEnterTokenModal(false);
                    window.location.reload();
                  }
                }}
              >
                Save Token
              </button>
            </div>
          </div>
        </ModalComponent>
      )}
      <div
        className="d-flex justify-content-end p-2"
        style={{ marginRight: "115px", marginTop: "14px" }}
      >
        <button
          width="200px"
          onClick={(e) => {
            e.preventDefault();
            console.log("setShowEnterTokenModal", showEnterTokenModal);
            setShowEnterTokenModal(true);
          }}
        >
          Change Token
        </button>
      </div>
      <div style={{ padding: "20px 50px" }}>
        {tokenFromStorage && (
          <FabRewardsComponent
            // rewardsServiceUrl="https://stag-fab-api-gateway.thriwe.com/"
            rewardsServiceUrl="https://prod-fab-api-gateway-ssl.thriwe.com/"
            token={tokenFromStorage}
            preferredLanguage={languages}
          />
        )}
      </div>
    </>
  );
}

export default App;
